export const SELECTION_LIMIT_MIN = 1;

export const SELECTION_LIMIT_MAX = 5;

export const SELECTION_MODES = {
  Exactly: 'exactly',
  UpTo: 'upTo',
  AtLeast: 'atLeast',
} as const;

export type SelectionMode =
  (typeof SELECTION_MODES)[keyof typeof SELECTION_MODES];
